// const server = 'http://localhost:7779';
const server = process.env.REACT_APP_API_URL || 'https://cloud.xn--am-yja.org';
export default server;
